<template>
  <answer-template
    :answer-type="'image'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'image-answer'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Send image</template>
    <template v-slot:content>
      <div class="img-box" @mouseover="onHover=true" @mouseleave="onHover=false">
        <div class="center-btn" v-show="onHover || noUrl" @click="setMediaUrl">
              <span class="icon">
                <font-awesome-icon icon="pen"></font-awesome-icon>
              </span>
        </div>
        <img class="image" :src="inputData.url">
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'ImageAnswer',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'send_image',
          url: '',
        };
      },
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      onHover: false,
      tempInput: '',
    };
  },
  methods: {
    toggleDirty() {
      this.$emit('dirty');
    },
    removeBlock() {
      this.$buefy.dialog.confirm({
        title: 'Removing image block',
        message: 'Are you sure to remove this image block?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('deleted');
        },
      });
    },
    setMediaUrl() {
      if (this.inputData.url) {
        this.tempInput = this.inputData.url;
      } else {
        this.tempInput = '';
      }
      this.$buefy.dialog.prompt({
        title: 'Image message',
        message: 'Please enter image URL. (Must be https://)',
        inputAttrs: {
          placeholder: 'e.g. https://dummyimage.com/600x400',
          value: this.tempInput,
          pattern:
            '^(https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$',
          title: 'URL must be https.',
        },
        onConfirm: (url) => {
          this.inputData.url = url;
          this.toggleDirty();
        },
      });
    },
  },
  computed: {
    noUrl() {
      return !this.inputData.url;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-answer {
  .img-box {
    background-color: #eee;
    border: 1px solid #eee;
    min-height: 200px;
    position: relative;
    .center-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -15px;
      margin-left: -20px;
      cursor: pointer;
      color: #797979;
      background-color: rgba(238, 238, 238, 0.8);
      border-radius: 50px;
      padding: 5px 10px;
      line-height: 20px;
      z-index: 10;
      &:hover {
        color: #ddd;
      }
    }
    .image {
      width: 100%;
      height: auto !important;
    }
  }
}
</style>
